import {useEffect, useState} from 'react';
import useTimeout from './useTimeout';


const COUNT_TIMEOUT_MILLIS = 80;

const calculateNewValue = (currentValue, targetValue) => {

    const delta = targetValue - currentValue;
    if (delta < 0) {

        return targetValue;
    }

    return currentValue + Math.ceil(delta / 4);
};


function useNumberCounter(targetNumber, scope = null) {

    const [currentNumber, setCurrentNumber] = useState(0);

    useEffect(() => {

        let timeout;
        if (currentNumber < targetNumber) {
            timeout = useTimeout(() => {

                const newCurrentNumber = calculateNewValue(currentNumber, targetNumber);
                setCurrentNumber(newCurrentNumber);

            }, COUNT_TIMEOUT_MILLIS, `useNumberCounter-${targetNumber}-${scope}`);
        }

        return () => {

            if (timeout) {
                timeout.clear();
            }
        };

    }, [currentNumber]);

    return currentNumber;
}


export default useNumberCounter;
